import React from 'react';
import './VisualHomepage.css';

// Shared logo mark — identical to the homepage brand mark.
const VisualLogoMark = ({ compact = false }) => (
  <div className={`visual-logo ${compact ? 'visual-logo--small' : ''}`} aria-hidden="true">
    <svg viewBox="0 0 72 72" role="img">
      <path d="M11 14h50c5 0 9 4 9 9s-4 9-9 9H41v25c0 6-5 11-11 11h-4c-6 0-11-5-11-11V32H11c-5 0-9-4-9-9s4-9 9-9Z" />
      <path d="M33 31v23" />
      <path d="M44 36v18" />
      <path d="M55 41v13" />
    </svg>
  </div>
);

export default VisualLogoMark;
